import { DateTime } from 'luxon';
import moment from 'moment';
import {
  ReconciliationStatus,
  ReconciliationDateFormatStatusUpdate
} from 'common/constants';

import {
  PaymentStatusUpdateDataType,
  ReconciliationReportDataType
} from './types';

const calculateTotalOnStatus = (
  data: ReconciliationReportDataType[] | undefined,
  status: string
): number =>
  data
    ? data.reduce(
        (total, item) =>
          total +
          (item.status === status ||
          status === ReconciliationStatus.PendingReconciled
            ? Number(item.paymentAmount)
            : 0),
        0
      )
    : 0;

export const getRCCTotalsInFooter = (
  data: ReconciliationReportDataType[] | undefined,
  selectedReconcileRecords: ReconciliationReportDataType[]
): {
  totalPending: number;
  totalSettled: number;
  totalVoided: number;
  totalReconciled: number;
  selectedTotal: number;
  totalAmount: number;
} => {
  const totalPending = calculateTotalOnStatus(
    data,
    ReconciliationStatus.Pending
  );
  const calcSettled = calculateTotalOnStatus(
    data,
    ReconciliationStatus.Settled
  );
  const totalVoided = calculateTotalOnStatus(data, ReconciliationStatus.Voided);
  const calcReconciled = calculateTotalOnStatus(
    data,
    ReconciliationStatus.Reconciled
  );
  const selectedTotalReconciled = calculateTotalOnStatus(
    selectedReconcileRecords,
    ReconciliationStatus.Reconciled
  );
  const selectedTotalSettled = calculateTotalOnStatus(
    selectedReconcileRecords,
    ReconciliationStatus.Settled
  );
  const selectedTotal = calculateTotalOnStatus(
    selectedReconcileRecords,
    ReconciliationStatus.PendingReconciled
  );
  const totalAmount = totalPending + calcSettled + totalVoided + calcReconciled;
  const totalReconciled = calcReconciled - selectedTotalReconciled;
  const totalSettled = calcSettled - selectedTotalSettled;

  return {
    totalPending,
    totalSettled,
    totalVoided,
    totalReconciled,
    selectedTotal,
    totalAmount
  };
};

export const formattedDate = (date: string): string =>
  DateTime.fromISO(date).isValid
    ? DateTime.fromISO(date).toFormat(ReconciliationDateFormatStatusUpdate)
    : '';

export const filterByDate = (
  data: ReconciliationReportDataType[] | undefined,
  settledDate: string
): ReconciliationReportDataType[] | undefined => {
  const formattedSettledDate = formattedDate(settledDate);
  if (formattedSettledDate) {
    return data?.filter(reconcileData =>
      moment(formattedDate(reconcileData?.settledDate)).isSameOrBefore(
        formattedSettledDate
      )
    );
  }
  return [];
};

export const totalSettledAmount = (
  reconcileRecordsPayload: PaymentStatusUpdateDataType
): number =>
  reconcileRecordsPayload.reduce((acc, val) => acc + val.settledAmount, 0);
